<template>
  <div class="stores-and-events-show">
    <Banner
      page="stores_and_events_show_page"
      :custom-banner="pageBanner"
    />
    <div
      v-if="!isEmpty(page)"
      class="stores-and-events-page"
    >
      <div
        class="stores-and-events-page-title"
        v-text="page.attributes['page-title']"
      />
      <div
        class="stores-and-events-page-description booking-service-description"
        v-html="page.attributes['page-description']"
      /><br>
      <div
        v-if="page.attributes['cta-url'] && page.attributes['cta-label']"
        class="cta-button">
        <a v-bind:href = "page.attributes['cta-url']" target="_blank" class="btn" v-html="page.attributes['cta-label']" />
      </div>

      <div class="row">
        <div class="col-lg-5">
          <img
            class="stores-and-events-page-image"
            :src="page.attributes.image"
          >
        </div>
        <div class="col-lg-7">
          <div
            class="stores-and-events-page-content booking-service-description"
            v-html="page.attributes.content"
          />
          <div
            v-if="page.attributes.terms.length > 0"
            class="stores-and-events-page-terms booking-service-description"
          >
            <div
              class="title"
              v-text="`${$t('common.termsAndConditions')}:`"
            />
            <div
              class="content"
              v-html="page.attributes.terms"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import Banner from './reusable/banner.vue'
import { fullUrl } from '@/modules/services/utilities'

const { mapGetters, mapActions } = createNamespacedHelpers('bookingService')

export default {
  name: 'StoresAndEventsShow',
  components: {
    Banner
  },
  data () {
    return {
      isEmpty: isEmpty
    }
  },
  computed: {
    ...mapGetters(['page']),
    pageBanner () {
      if (!isEmpty(this.page) && this.page.attributes.banner) {
        return {
          attributes: {
            image: this.page.attributes.banner,
            link: this.page.attributes['banner-link']
          }
        }
      } else {
        return null
      }
    }
  },
  watch: {
    page (value) {
      // SEO details
      this.$store.commit('setSeoMetaTitle', value.attributes['page-title'])
      const country = this.$t('country', I18n.siteCountryLs)
      this.$store.commit(
        'setSeoMetaDescription',
        this.$t('bookingService.metaDescription', { country: country })
      )
      this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
      this.$store.commit('setSeoUpdate', true)
    },
    '$route.params.id': function () {
      this.fetchPage(this.$route.params.id)
    }
  },
  mounted () {
    this.fetchPage(this.$route.params.id)
  },
  methods: {
    ...mapActions(['fetchPage'])
  }
}
</script>

<style lang='scss' scoped>
.stores-and-events-page {
  line-height: 20px;

  .stores-and-events-page-title {
    @include font-weight-bold;
    text-transform: uppercase;
    font-size: 13px;
    margin-bottom: 5px;
  }

  .stores-and-events-page-description, .stores-and-events-page-content, .stores-and-events-page-terms {
    line-height: 20px;
  }

  .cta-button {
    line-height: 20px;
  }

  .stores-and-events-page-image {
    width: 100%;
    margin-bottom: 20px;
  }

  .stores-and-events-page-terms {
    padding-top: 20px;

    .title {
      @include font-weight-bold;
      text-transform: uppercase;
    }

    .content {
      margin-top: 10px;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }

  .row {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
